import { defineComponent, computed, getCurrentInstance } from "vue";
import DownloadAllResources from "@pt/components/download-all-resources/index.vue";
export default defineComponent({
    components: {
        DownloadAllResources: DownloadAllResources
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        // 如后面追加下拉选项，应将此判断删除(目前只有一个，跟随子选项权限)
        var showMoreButton = computed(function() {
            return !store.getters.isPlayableTrial;
        });
        return {
            showMoreButton: showMoreButton
        };
    }
});
